module.exports = __webpack_public_path__ + "img/bg11.aa26b272.png";